export default "__VITE_ASSET__CKQMVXGI__"